import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import './Budowa.css';
import Content from '../Content/Content';

var h1 = {
    marginBottom: '3em'
};
var margin = {
    paddingBottom: '4em',
    paddingTop: '3em'
};
class Budowa extends Component {
    render () {
        return (
            <Content>
            <div style={margin}>
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                <h1 style={h1}>Strona jeszcze w budowie. Przepraszamy za trudności.</h1>
                </ScrollAnimation>
            </div>
            </Content>
        );
    }
}

export default Budowa;


// WEBPACK FOOTER //
// ./src/Budowa/Budowa.js